import { Button, Box, Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import DotMenu from "../DotMenu";
import BuildIcon from "@mui/icons-material/Build";
import BadgeIcon from "@mui/icons-material/Badge";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import Translate from "../../utils/Translate";
import { formatDate } from "../../utils/dateTimeFormat";
import { Cloud } from "@mui/icons-material";
import DigitalLicenseColumn from "./DigitalLicenseColumn";
import { accessKeys, hasAccess } from "../../utils/userAccess";

export default function LicensCard(props) {
  return (
    <Card sx={{ padding: "16px", marginBottom: "16px", transform: "translateZ(0)", marginTop: "0.5em" }}>
      <Box sx={{ position: "fixed", top: "18px", right: "16px" }}>
        {props.dotMenuActions && props.dotMenuActions.length > 0 && (
          <DotMenu content={props.dotMenuActions} horizontal />
        )}
      </Box>
      <Grid container spacing={4} direction="column" sx={{ padding: "30px 0px 16px 18px" }}>
        <Grid container alignItems="center">
          <BadgeIcon />
          <Box marginLeft="19px">{props.row.licenseGroupDescription}</Box>
        </Grid>
        <Grid container alignItems="center">
          <BuildIcon />
          <Box marginLeft="19px">
            {
              <span>
                {[props.row.licenseGroupPractice, props.row.licenseGroupTheory].filter((s) => !!s).join(", ")}
              </span>
            }
          </Box>
        </Grid>
        <Grid container alignItems="center">
          <CalendarTodayIcon />
          <Box marginLeft="19px">
            {props.row.validFrom ? formatDate(props.row.validFrom) : ""}
            {props.row.validTo ? " - " + formatDate(props.row.validTo) : ""}
          </Box>
        </Grid>
        <Grid container alignItems="center">
          <CoPresentIcon />
          <Box marginLeft="19px">{props.row.instructorName}</Box>
        </Grid>
        <Grid container alignItems="center">
          <EventAvailableIcon />
          <Box marginLeft="19px">{props.row.lastPrintDate && formatDate(props.row.lastPrintDate)}</Box>
        </Grid>
        {hasAccess(accessKeys.digitalLicenses) && (
          <Grid container alignItems="center">
            <Cloud />
            <Box marginLeft="19px">
              <DigitalLicenseColumn license={props.row} />
            </Box>
          </Grid>
        )}
        <Grid container justifyContent="flex-end">
          <Button
            variant="outlined"
            disabled={!props.isOrderLicenseAvailable(props.row.licenseGroupDescription?.trim())}
            onClick={() => props.handleOrderLicensesClick(props.row.actorLicenseId)}
          >
            {Translate.get("OrderLicense")}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}
